import * as types from "./types";
import http from "@/http";
import { preprodConfig } from "./initialValues";

const actions = {
  [types.LOAD_LIBRARY_ENPOINTS]({ dispatch, commit, state, rootState }, { domain, type }) {
    const s3UrlEndpointKey = 's3Url';
    const currentEnv = rootState.utils.env;
    const { caid, configuration : {region} } = this.state.utils;
    const regionPrefix = (region && region==="asia") ? "-apac" : "";

    if (Object.keys(state[type]).includes(s3UrlEndpointKey)) {
      return  Promise.resolve(state[type]);
    }

    const url = `${domain}${state[type].endpoints.replace(/\{\ENV\}/g, currentEnv)}/configurations/${caid}`;
    const file = `endpoints${ !type || type === 'customizer' ? '' : `-${ type }` }.json`;

    return http.get(`${ url }/${ file }`)
      .then(({ data }) => {
        // adds the domain to all endpoints that are relative paths and start with a slash
        // if domain points to an absolute path
        if (domain && /^https?:\/\//i.test(domain)) {
          Object.keys(data).forEach(endpointName => {
            const skipPrefixing = preprodConfig.endpointsToSkipDomainPrefixing[type] ? preprodConfig.endpointsToSkipDomainPrefixing[type].includes(endpointName) : false;
            if (!skipPrefixing && !/^https?:\/\//i.test(data[endpointName]) && /^\//.test(data[endpointName])) {
              data[endpointName] = domain + data[endpointName];
            }
          });
        }

        // endpoints to point to preprod
        if (preprodConfig.envsToReplace.includes(currentEnv)) {
          Object.keys(data).forEach(endpointName => {
            if (preprodConfig.endpoints.includes(endpointName)) {
              data[endpointName] = data[endpointName].replace(/\{\$env\}/g, preprodConfig.value);
              data[endpointName] = data[endpointName].replace(/\{\$region\}/g, regionPrefix);
            }
          });
        }

        let dataStr = JSON.stringify(data).replace(/\{\$env\}/g, currentEnv);
        dataStr = dataStr.replace(/\{\$region\}/g, regionPrefix);

        // points from pre-prod to prod
        if (currentEnv === "prod" || currentEnv === "www2") {
          dataStr = dataStr.replace(/pre-/g, "");
        }

        // adds the domain as s3UrlEndpoint
        const endpoints = { ...JSON.parse(dataStr), [s3UrlEndpointKey]: domain };
        commit(types.SET_ENDPOINTS, { endpoints, type });
        return endpoints;
      });
  }
};

export default actions;
